import { render, staticRenderFns } from "./ShoppingListProducts.vue?vue&type=template&id=96ced6e2&scoped=true&"
import script from "./ShoppingListProducts.vue?vue&type=script&lang=js&"
export * from "./ShoppingListProducts.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListProducts.vue?vue&type=style&index=0&id=96ced6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ced6e2",
  null
  
)

export default component.exports